module.exports = __webpack_public_path__ + "static/budweiser-67ffd7f757b18ace04b2bdb312d2ea8a.png";